import script from "./HolidaySelection.vue?vue&type=script&lang=ts&setup=true"
export * from "./HolidaySelection.vue?vue&type=script&lang=ts&setup=true"

import "./HolidaySelection.vue?vue&type=style&index=0&id=1c17920c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c17920c"]])

export default __exports__